/* ================================
GLOBAL CSS
================================ */

import "./App.css";
import { API } from "./config/api";

/* ================================
REACT ROUTER
================================ */

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import ScrollToTop from "./Client/Pages/ScrollToTop";
import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
/* ================================
CLIENT IMPORTS
================================ */

import Navbar from "./Client/Layouts/Navbar";
import Footer from "./Client/Layouts/Footer";

import Home from "./Client/Pages/Home";
import Contact from "./Client/Pages/Contact";
import ProductDetails from "./Client/Pages/ProductDetails";
import HouseRentDetails from "./Client/Pages/HouseRentDetails";
import Wishlist from "./Client/Pages/Wishlist";
import Register from "./Client/Pages/Register";
import Login from "./Client/Pages/Login";
import Machine from "./Client/Pages/Machine";
import House from "./Client/Pages/House";
import Designer from "./Client/Pages/Designer";
import DesignerDetails from "./Client/Pages/DesignerDetails";
import About from "./Client/Pages/About";

/* ================================
USER IMPORTS
================================ */

import UserSidebar from "./User/layouts/Sidebar";
import UserHeader from "./User/layouts/UserHeader";

import UserDashboard from "./User/Pages/Dashboard";

import AddDesigner from "./User/Pages/AddDesigner";

import Profile from "./User/Pages/Profie";
import AChangePassword from "./Admin/Pages/ChangePassword";
import Logout from "./User/Pages/Logout";

/* ================================
ADMIN IMPORTS
================================ */

import AdminSidebar from "./Admin/layouts/Sidebar";
import AdminHeader from "./Admin/layouts/UserHeader";

import AdminDashboard from "./Admin/Pages/Dashboard";
import AdminAddMachine from "./Admin/Pages/Addmachine";

import AdminAddworkspace from "./Admin/Pages/Addworkspace";

import Pendingmachine from "./Admin/Pages/Pendingmachine";
import Pendingdesigner from "./Admin/Pages/Pendingdesigner";
import Pendingworkspace from "./Admin/Pages/Pendingworkspace";

import Manageuser from "./Admin/Pages/Manageuser";
import AdminProfile from "./Admin/Pages/Profie";
import AdminChangePassword from "./Admin/Pages/ChangePassword";
import AdminLogout from "./Admin/Pages/Logout";

import Orders from "./Admin/Pages/Orders";

/* ================================
LAYOUT HANDLER
================================ */

import ProtectedRoute from "./ProtectedRoute"; // Import the protector
import ContactMsg from "./Admin/Pages/ContactMsg";
import SearchResults from "./Client/Pages/Searchresult";
import AddDesign from "./Admin/Pages/AddDesign";
import ViewDesign from "./Admin/Pages/ViewDesign";

import DesigneDetails from "./Client/Pages/DesigneDetails";
import Cart from "./Client/Pages/Cart";
import MyOrders from "./Client/Pages/Orders";
import OrderDetails from "./Client/Pages/Orderdtails";

import PageTitle from "./PageTitle";
import AdsPlanManager from "./Admin/Pages/AdsPlanManager";

import Calculate from "./Client/Pages/Calculate";

import SellDesigns from "./Client/Pages/SellDesigns";
import Settings from "./Admin/Pages/Settings";
import SellDesignDetails from "./Client/Pages/SellDesigndetails";
import Transaction from "./Admin/Pages/Transaction";
import UserTransaction from "./Client/Pages/UserTransaction";
import Design from "./Client/Pages/Design";

import Designs from "./User/Pages/Designs";
import AddPayment from "./Admin/Pages/AddPayment";
import PaymentDetails from "./User/Pages/PaymentDetails";

import CreateSupplierType from "./Admin/Pages/CreateSupplierType";
import Supplier from "./Client/Pages/Supplier";
import CSupplier from "./User/Pages/Supplier";
import PendingSupplier from "./Admin/Pages/PendingSupplier";

import Terms from "./User/Pages/Terms";
import AddSubcategory from "./Admin/Pages/AddSubcategory";
import ViewSketchers from "./Admin/Pages/ViewSketchers";
import Sketcher from "./Client/Pages/Sketchers";
import Policy from "./Client/Pages/Policy";
import CTerms from "./Client/Pages/Terms";
import Hiring from "./Client/Pages/Hiring";
import AddHiring from "./User/Pages/AddHiring";
import CUserTransaction from "./User/Pages/UserTransaction";
import Viewhiring from "./Admin/Pages/Viewhiring";
import AddWork from "./User/Pages/Addwork";
import Viewwork from "./Admin/Pages/Viewwork";
import WorkList from "./Client/Pages/WorkList";
import MyBids from "./Client/Pages/MyBids";
import WorkDetails from "./Client/Pages/WorkDetails";
import Concept from "./Client/Pages/Concept";
import ConceptDetails from "./Client/Pages/ConceptDetails";
import Conceptimages from "./Admin/Pages/Conceptimages";
import Rules from "./Admin/Pages/Rules";

function Layout() {
  const location = useLocation();
  const isUser = location.pathname.startsWith("/user");
  const isAdmin = location.pathname.startsWith("/admin");

  /* ================================
     CLIENT LAYOUT (Public)
     ================================ */
  if (!isUser && !isAdmin) {
    return (
      <>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/productdetails/:id" element={<ProductDetails />} />
          <Route path="/houserentdetails/:id" element={<HouseRentDetails />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/machine" element={<Machine />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/house" element={<House />} />
          <Route path="/designer" element={<Designer />} />
          <Route path="/sketchers" element={<Sketcher />} />
          <Route path="/designerdetails/:id" element={<DesignerDetails />} />
          <Route path="/designe-details/:id" element={<DesigneDetails />} />
          <Route path="/design-details/:id" element={<SellDesignDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<clientProfile />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/designs" element={<Design />} />
          <Route path="/designs" element={<Design />} />
          <Route path="/work-details" element={<WorkDetails />} />

          <Route path="/cart" element={<Cart />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/buy-designs" element={<SellDesigns />} />
          <Route path="/myorders" element={<MyOrders />} />

          <Route path="/order-details" element={<OrderDetails />} />
          <Route path="/Work-list" element={<WorkList />} />
          <Route path="/Transaction-details" element={<UserTransaction />} />
          <Route path="/Calculate" element={<Calculate />} />
          <Route path="/Terms" element={<CTerms />} />
          <Route path="/supplier" element={<Supplier />} />
          <Route path="/Hiring" element={<Hiring />} />
          <Route path="/Concept" element={<Concept />} />
          <Route path="/concepts/:folderName" element={<ConceptDetails />} />
        </Routes>
        <Footer />
      </>
    );
  }

  if (isUser) {
    return (
      <ProtectedRoute allowedAccountType="provider">
        <UserSidebar />

        <div className="main-content">
          <UserHeader />
          <div className="dashboard-content">
            <Routes>
              <Route path="/user" element={<UserDashboard />} />
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/add-machine" element={<AdminAddMachine />} />

              <Route
                path="/user/add-designer"
                element={<AddDesigner type="designer" />}
              />

              <Route
                path="/user/add-sketcher"
                element={<AddDesigner type="sketcher" />}
              />
              <Route
                path="/user/add-workspace"
                element={<AdminAddworkspace />}
              />

              <Route path="/user/designs" element={<Designs />} />

              <Route
                path="/user/payment-details"
                element={<PaymentDetails />}
              />
              <Route path="/user/profile" element={<Profile />} />
              <Route path="/user/terms" element={<Terms />} />
              <Route path="/user/add-hiring" element={<AddHiring />} />
              <Route path="/user/transactions" element={<CUserTransaction />} />
              <Route path="/user/order-details" element={<OrderDetails />} />
              <Route
                path="/user/change-password"
                element={<AChangePassword />}
              />
              <Route path="/user/add-work" element={<AddWork />} />
              <Route path="/user/logout" element={<Logout />} />
              <Route path="/user/logout" element={<Logout />} />
              <Route path="/user/:type" element={<CSupplier />} />
              <Route path="/user/myBids" element={<MyBids />} />
            </Routes>
          </div>
        </div>
      </ProtectedRoute>
    );
  }

  if (isAdmin) {
    return (
      <ProtectedRoute allowedRole="admin">
        <AdminSidebar />
        <div className="main-content">
          <AdminHeader />
          <div className="dashboard-content">
            <Routes>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/add-machine" element={<AdminAddMachine />} />
              <Route path="/admin/add-designer" element={<AddDesigner />} />
              <Route
                path="/admin/add-workspace"
                element={<AdminAddworkspace />}
              />

              <Route
                path="/admin/view-designer"
                element={<Pendingdesigner />}
              />
              <Route path="/admin/view-sketcher" element={<ViewSketchers />} />
              <Route
                path="/admin/pending-machine"
                element={<Pendingmachine />}
              />

              <Route
                path="/admin/pending-workspace"
                element={<Pendingworkspace />}
              />
              <Route path="/admin/users" element={<Manageuser />} />

              <Route path="/admin/profile" element={<AdminProfile />} />
              <Route path="/admin/contactmsg" element={<ContactMsg />} />

              <Route
                path="/admin/change-password"
                element={<AdminChangePassword />}
              />
              <Route path="/admin/add-design" element={<AddDesign />} />
              <Route path="/admin/view-design" element={<ViewDesign />} />
              <Route path="/admin/logout" element={<AdminLogout />} />
              <Route path="/admin/orders" element={<Orders />} />
              <Route path="/admin/ads-plan" element={<AdsPlanManager />} />
              <Route path="/admin/sub-category" element={<AddSubcategory />} />
              <Route path="/admin/concept-images" element={<Conceptimages />} />
              <Route
                path="/admin/view-workspace"
                element={<Pendingworkspace />}
              />
              <Route path="/admin/view-machine" element={<Pendingmachine />} />
              <Route
                path="/admin/transaction-details"
                element={<Transaction />}
              />

              <Route path="/admin/add-payment" element={<AddPayment />} />

              <Route path="/admin/Designer-Reports" element={<Settings />} />
              <Route path="/admin/rules" element={<Rules />} />
              <Route
                path="/admin/create-supplier-type"
                element={<CreateSupplierType />}
              />

              <Route
                path="/admin/manage-supplier"
                element={<PendingSupplier />}
              />
              <Route path="/admin/view-hiring" element={<Viewhiring />} />
              <Route path="/admin/view-work" element={<Viewwork />} />
              <Route path="/admin/:type" element={<CSupplier />} />
              <Route
                path="/admin/manage-supplier/:type"
                element={<PendingSupplier />}
              />
            </Routes>
          </div>
        </div>
      </ProtectedRoute>
    );
  }
}

/* ================================
MAIN APP
================================ */

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const hasVisitedRef = useRef(false);

  useEffect(() => {
    if (hasVisitedRef.current) return;

    const today = new Date().toISOString().split("T")[0];
    const lastVisit = localStorage.getItem("visitor_date");

    if (lastVisit !== today) {
      hasVisitedRef.current = true;

      const user = JSON.parse(sessionStorage.getItem("user") || "{}");
      const userId = user?.id || "";

      fetch(API.COUNT_VISITOR, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId }),
      })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then((data) => {
          if (
            data.status === true ||
            data.status === "true" ||
            data.status === 1 ||
            data.success === true
          ) {
            localStorage.setItem("visitor_date", today);
          } else {
            console.error("Visitor count failed on backend:", data);

            hasVisitedRef.current = false;
          }
        })
        .catch((err) => {
          console.error("Error logging visitor:", err);
          hasVisitedRef.current = false;
        });
    }
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageTitle />
      <Layout />
    </BrowserRouter>
  );
}

export default App;
